var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contracts-list-component',{attrs:{"routeNameToContractCreate":_vm.route_name_create,"routeNameToContractDetails":_vm.route_name_details}})}
var staticRenderFns = []

export { render, staticRenderFns }